<span class="hypometer-widget content-banner" *ngIf="promo">
	<div elevation="5" class="card rounded-lg">
		<div class="row" justify="center" align="stretch">
			<div cols="12" md="3" class="col pa-0 cutoff">
				<div class="banner-image-d d-md-flex d-none">
					<picture *ngIf="promo.thumbnail?.dynamic_url">
						<source [srcset]="promo.thumbnail.dynamic_url + '?w=200&fm=webp'" type="image/webp">
						<source [srcset]="promo.thumbnail.dynamic_url + '?w=200'" [type]="promo.thumbnail.mime_type">
						<img [alt]="promo.thumbnail.custom_properties.alt_text" [src]="promo.thumbnail.dynamic_url + '?w=200'" loading="lazy">
					</picture>
				</div>
				<div class="banner-image-m d-sm-flex d-md-none">
					<picture *ngIf="promo.thumbnail_mobile?.dynamic_url">
						<source [srcset]="promo.thumbnail_mobile.dynamic_url + '?w=700&fm=webp'" type="image/webp">
						<source [srcset]="promo.thumbnail_mobile.dynamic_url + '?w=700'" [type]="promo.thumbnail_mobile.mime_type">
						<img [alt]="promo.thumbnail_mobile.custom_properties.alt_text" [src]="promo.thumbnail_mobile.dynamic_url + '?w=700'" loading="lazy">
					</picture>

					<div class="mobile-title" *ngIf="pureMobileTitle.length" [innerHTML]="treatedMobileTitle"></div>

					<a *ngIf="promo.review_text" class="cta-link overflow review-text" [href]="promo.review_url"
						[target]="promo.review_is_new_tab ? '_blank' : '_self'" [innerHTML]="treatedReviewText">
					</a>

				</div>
			</div>
			<div cols="12" md="6" justify="center" align="center" class="col banner-content-checklist">
				<div class="d-md-flex banner-content align-center"
					[class.desktop-only]="promo.version === 'conversion_banner'">
					<picture *ngIf="promo.product_thumbnail?.dynamic_url && promo.version !== 'conversion_banner'">
						<source [srcset]="promo.product_thumbnail.dynamic_url + '?w=50&fm=webp'" type="image/webp">
						<source [srcset]="promo.product_thumbnail.dynamic_url + '?w=50'" [type]="promo.product_thumbnail.mime_type">
						<img [alt]="promo.product_thumbnail.custom_properties.alt_text" [src]="promo.product_thumbnail.dynamic_url + '?w=50'" loading="lazy"
							class="m-right-10 conversion-icon">
					</picture>
					<div class="content-desc" [innerHTML]="treatedTitle"></div>
				</div>
				<div class="checklist d-sm-flex d-md-none">
					<ng-container *ngIf="treatedChecklist?.length">
						<p class="list" *ngFor="let list of treatedChecklist">
							<img class="m-right-10 tick-box"
								src="https://cdn.ciphersports.io/images/dimers-site/Tick-blue.svg" />
							<span [outerHTML]="list"></span>
						</p>
					</ng-container>
				</div>
			</div>
			<div cols="12" md="3" justify="center" align="center" class="col">
				<div class="cta">
					<a
						class="btn no-text-transform"
						id="bookie-button"
						[style.font-weight]="promo.tnc_btn_weight ? promo.tnc_btn_weight : '700'"
						[style.color]="promo.tnc_txt_color ? promo.tnc_txt_color : 'initial'"
						[style.margin-bottom]="promo.review_text ? '10px' : '0px'"
						[style.font-size]="'1.1rem'"
						[style.background-color]="promo.btn_color ? promo.btn_color : 'initial'"
						[style.height]="promo.btn_height ? promo.btn_height + 'px' : 'initial'"
						(click)="redirectBookiePromo(
							promo.state_affiliate_link?.url
							? promo.state_affiliate_link.url : promo.callback_url,
							promo.version === 'conversion_banner' ? 'promo' : 'direct',
							promo
						)"
						[target]="promo.is_new_tab ? '_blank' : '_self'" x-large
						[innerHTML]="treatedButtonText">
					</a>
					<a class="cta-link d-md-flex d-none" [href]="promo.review_url" *ngIf="promo.review_text"
						[target]="promo.review_is_new_tab ? '_blank' : '_self'" [innerHTML]="treatedReviewText">
					</a>

				</div>
			</div>
		</div>
	</div>
</span>